import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import {
  APIErrorResponse,
  InternalHoursLog,
  PostInternalHoursLog,
} from '@/types'
import { getUseInternalHoursLogsKey } from './useInternalHoursLogs'
import { getUseInternalHoursBalanceKey } from './useInternalHoursBalance'

export const usePostInternalHoursLog = (): UseMutationResult<
  InternalHoursLog,
  APIErrorResponse,
  PostInternalHoursLog
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()
  const listKey = getUseInternalHoursLogsKey()
  const balanceKey = getUseInternalHoursBalanceKey()

  return useMutation(
    (params) =>
      client
        .post('/hours_reporting/internal-hours/', params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries(listKey),
          queryClient.invalidateQueries(balanceKey),
        ])
      },
    }
  )
}
